// extracted by mini-css-extract-plugin
module.exports = {"logo":"terms_logo__3UZXc","title":"terms_title__-PGxg","link":"terms_link__LnpZZ","button":"terms_button__36c3d"};